import { motion } from "framer-motion";
import { PartyPopper, Utensils, ChefHat, Check } from "lucide-react";
import { CHEF_PICKS, BRAND } from "../../data/menu";

const rise = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export default function Bento() {
  return (
    <section id="specials" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={rise}
          className="mb-12"
        >
          <p className="text-sm uppercase tracking-[0.3em] font-bold text-[#d97706] mb-3">
            More Than a Meal
          </p>
          <h2 className="font-display text-5xl md:text-6xl font-bold tracking-tight text-[#331818]">
            Tiffins, Parties &amp; Chef's Picks
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6 auto-rows-[minmax(0,1fr)]">
          {/* Party orders — large dark tile */}
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={rise}
            className="md:col-span-2 relative overflow-hidden rounded-3xl bg-[#2b1414] p-8 md:p-12 text-[#f7f0e0] min-h-[320px] flex flex-col justify-between"
          >
            <img
              src={BRAND.interior}
              alt=""
              className="pointer-events-none absolute right-0 top-0 h-full w-1/2 object-cover opacity-25"
            />
            <div className="relative">
              <PartyPopper className="text-[#d97706]" size={34} />
              <h3 className="mt-5 font-display text-4xl md:text-5xl font-semibold">Party &amp; Bulk Orders</h3>
              <p className="mt-3 max-w-md text-[#f7f0e0]/80 leading-relaxed">
                Birthdays, get-togethers, festivals &amp; small functions — we
                cater authentic Maharashtrian spreads that guests remember.
              </p>
            </div>
            <button
              data-testid="bento-party-cta"
              onClick={() => document.getElementById("visit")?.scrollIntoView({ behavior: "smooth" })}
              className="relative mt-6 inline-flex w-fit items-center gap-2 rounded-full bg-[#d97706] px-6 py-3 text-sm font-semibold text-[#2b1414] transition-colors duration-300 hover:bg-[#f7f0e0]"
            >
              Enquire for Catering
            </button>
          </motion.div>

          {/* Daily tiffin */}
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={rise}
            className="relative overflow-hidden rounded-3xl bg-[#7a1f1f] p-8 text-[#f7f0e0] min-h-[320px] flex flex-col justify-between"
          >
            <div>
              <Utensils className="text-[#f7f0e0]" size={30} />
              <h3 className="mt-5 font-display text-3xl font-semibold">Daily Tiffin</h3>
              <p className="mt-3 text-[#f7f0e0]/80 leading-relaxed">
                Wholesome veg &amp; chicken tiffins — chapatis, sabzi, dal, rice
                &amp; pickle. Monthly plans available.
              </p>
            </div>
            <span className="mt-6 inline-flex w-fit items-center gap-2 rounded-full bg-[#f7f0e0]/15 px-4 py-2 text-xs font-semibold uppercase tracking-wider">
              <Check size={14} /> Free home delivery*
            </span>
          </motion.div>

          {/* Chef recommends */}
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={rise}
            className="md:col-span-3 rounded-3xl bg-[#f7f0e0] ring-1 ring-[#7a1f1f]/15 p-8 md:p-10"
          >
            <div className="flex items-center gap-3 mb-6">
              <ChefHat className="text-[#7a1f1f]" size={28} />
              <h3 className="font-display text-3xl font-semibold text-[#331818]">Chef's Recommendations</h3>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {CHEF_PICKS.map((p) => (
                <div
                  key={p}
                  className="flex items-center gap-2.5 rounded-xl bg-[#eae0c9]/70 px-4 py-3 text-[#331818]"
                >
                  <span className="h-2 w-2 rounded-full bg-[#d97706]" />
                  <span className="font-medium">{p}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
